import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../../../constants/componentTypes";
import * as navigationActions from "../../../../../actions/navigationActions";
import * as windowService from "../../../../../services/windowService";

class RebootPCModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseRebootPCModalAction();
    };

    handleNoButtonClick = () => {
        this.props.dispatchCloseRebootPCModalAction();
    };

    handleYesButtonClick = () => {
        windowService.rebootPc();
    };

    render() {
        return (
            <div id="modal" className="default-modal ig-restart-modal ig-small-modal">
                <div className="modal-content">
                    <div className="col-xs-12 ">
                        <Translate value="dialog.reallyRebootPC" />
                    </div>
                    <div className="modal-footer">
                        <div className="col-xs-6 text-right">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleNoButtonClick}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.no" />
                            </button>
                        </div>
                        <div className="col-xs-6 text-left ">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleYesButtonClick}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.yes" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseRebootPCModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INTERGAMMA_REBOOT_PC_MODAL));
        }
    };
};

export default RebootPCModal = connect(mapStoreToProps, mapDispatchToProps)(RebootPCModal);
